import { render, staticRenderFns } from "./parameterLampList.vue?vue&type=template&id=1ed8e5c8&scoped=true&"
import script from "./parameterLampList.vue?vue&type=script&lang=js&"
export * from "./parameterLampList.vue?vue&type=script&lang=js&"
import style0 from "./parameterLampList.vue?vue&type=style&index=0&id=1ed8e5c8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./parameterLampList.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8e5c8",
  null
  
)

export default component.exports